import type { components } from '@pba/types-openapi-client';
import { useMutation } from 'query';
import { getCurrentUserTimezone } from 'common/utils';
import { signUp } from '../../services';

type MutationVariables = {
  email: string;
  firstName: string;
  invitationToken?: string;
  lastName: string;
  organizationId?: string;
  password: string;
  publicCommunityId?: string;
  recaptchaToken?: string;
};

export const useSignUpMutation = () =>
  useMutation<components['schemas']['UserDetail'], MutationVariables>({
    async mutationFn({
      email,
      firstName,
      invitationToken,
      lastName,
      organizationId,
      password,
      publicCommunityId,
      recaptchaToken,
    }) {
      const response = await signUp({
        body: {
          user: {
            email,
            first_name: firstName,
            join_community_id: publicCommunityId,
            last_name: lastName,
            password,
            password_confirmation: password,
            recaptcha_token: recaptchaToken,
            time_zone: getCurrentUserTimezone(),
          },
        },
        params: {
          invitation_token: invitationToken,
          organization_id: organizationId,
        },
      });

      // TODO: Do not return DataObject
      return response.data;
    },
  });
